import { Bubble } from 'vue-chartjs'
import { commaFormatString, isDecimal } from '@/helpers'
import { debounce } from 'lodash'

export default Bubble.extend({
  props: {
    chartId: {
      type: String,
      default: 'viewership-graph'
    },
    chartData: {
      type: Object,
      required: true
    },
    axises: {
      type: Object,
      required: true
    },
    onClick: {
      type: Function
    }
  },
  computed: {
    options () {
      return {
        onClick: (event, elements) => {
          if (elements.length === 0) return
          if (this.onClick) {
            this.onClick(this.chartData.datasets[elements[0]._datasetIndex].network)
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        layout: {
          padding: {
            left: 0,
            right: 25,
            top: 20,
            bottom: 0
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7',
              display: true
            },
            ticks: {
              fontSize: 13,
              min: this.axises.x.min,
              max: this.axises.x.max,
              callback: function (value, index, values) {
                return index === values.length - 1 || (index === 0 && value !== 0) ? '' : value === 0 ? 0 : value.toFixed(3)
              }
            }
          }],
          yAxes: [{
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#0052E7',
              display: true
            },
            ticks: {
              padding: 2,
              fontSize: 13,
              min: this.axises.y.min,
              max: this.axises.y.max,
              callback: function (value, index, values) {
                return index === values.length - 1 || (index === 0 && value !== 0) ? '' : isDecimal(value) ? value.toFixed(1) : value
              }
            }
          }]
        },
        animation: {
          duration: 0
        },
        tooltips: {
          bodyFontStyle: 'bold',
          footerFontStyle: 'normal',
          displayColors: false,
          callbacks: {
            label: function (tooltip, data) {
              return `${data.datasets[tooltip.datasetIndex].label}`
            },
            footer: function (tooltip, data) {
              return `Rating: ${commaFormatString(String(tooltip[0].xLabel.toFixed(3)))} Index: ${commaFormatString(String(tooltip[0].yLabel))}`
            }
          }
        }
      }
    }
  },
  methods: {
    renderChartOnDataChange: debounce(function () {
      this._chart ? this._chart.destroy() : undefined
      this.renderChart(this.chartData, this.options)
    }, 100)
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    'chartData': function () {
      this.renderChartOnDataChange()
    },
    'options': function () {
      this.renderChartOnDataChange()
    }
  }
})



// WEBPACK FOOTER //
// ./src/app/appComponents/graphs/viewership/components/ViewershipGraph.js